(ns rothko.header.spec
  (:require [clojure.spec.alpha :as s]
            [rothko.component.spec :as component-spec]))

(s/def ::header-logo
  (s/cat
   :props (s/keys :opt-un [::component-spec/class ::component-spec/appearance]
                  :req-un [::logo-width ::logo-name])
   :children ::component-spec/children))

(s/def ::sign-in-out-button
  (s/cat
   :props (s/keys :opt-un [::component-spec/class ::component-spec/appearance]
                  :req-un [::sign-out-handler
                           ::sign-out-text
                           ::sign-in-text
                           ::login-path])
   :children ::component-spec/children))

(s/def ::menu-open? (s/or :bool boolean?
                          :nil nil?))
(s/def ::left-container vector?)
(s/def ::right-container vector?)
(s/def ::side-nav vector?)

(s/def ::header
  (s/cat
   :props (s/keys :opt-un [::component-spec/class
                           ::component-spec/appearance
                           ::left-container
                           ::right-container
                           ::side-nav
                           ::menu-open?])))
